import { IconFooter } from "~/components/layout/IconFooter";
import { Mail } from "lucide-react";
import { Button } from "~/components/ui/button";
import { DiscordLogoIcon } from "@radix-ui/react-icons";
import { useLoaderData, json, useLocation, useNavigate } from "@remix-run/react";
import { authenticator } from "~/.server/auth";
import { LoaderFunctionArgs, MetaFunction } from "@remix-run/node";
import { getAllCustomerData } from "~/.server/models/customer";
import { generateMeta } from "~/utils/meta";

export const meta: MetaFunction = () => {
    return generateMeta({
        title: "Support",
        index: false,
    });
};

export async function loader({ request }: LoaderFunctionArgs) {
    const user = await authenticator.isAuthenticated(request, {})
    const isLoggedIn = user !== null;
    let patron = null;
    if (isLoggedIn) {
        patron = await getAllCustomerData(user.id);
    }

    return json({ isLoggedIn, patron });
}

export default function Support() {
    const navigate = useNavigate();
    const location = useLocation();
    const { isLoggedIn, patron } = useLoaderData<typeof loader>();
    return (
        <div className="flex flex-col min-h-screen">
            <main className="flex-1 flex items-center justify-center p-4 animate-fade-in">
                <div className="max-w-md w-full space-y-8">
                    <div className="text-center">
                        <h1 className="text-2xl font-semibold tracking-tight mb-4">
                            Support
                        </h1>
                        <p className="text-muted-foreground mb-8">
                            Get in touch with us through Discord or email
                        </p>
                    </div>

                    <div className="space-y-4">
                        <a
                            href="https://discord.gg/PKUZXqBvmC"
                            target="_blank"
                            rel="noopener noreferrer"
                            className="w-full"
                        >
                            <Button
                                className="w-full"
                                variant="outline"
                            >
                                <DiscordLogoIcon className="mr-2 h-5 w-5" />
                                Join our Discord
                            </Button>
                        </a>

                        <a
                            href="mailto:info@findpowerpeople.com"
                            className="w-full"
                        >
                            <Button
                                className="w-full"
                                variant="outline"
                            >
                                <Mail className="mr-2 h-5 w-5" />
                                info@findpowerpeople.com
                            </Button>
                        </a>
                    </div>

                    <div className="text-center text-sm text-muted-foreground">
                        <a href="/privacy" className="hover:underline">
                            Privacy Policy
                        </a>
                    </div>
                </div>
            </main>

            <IconFooter
                icons={[
                    { id: 'explore', route: '/explore' },
                    { id: isLoggedIn ? 'my-events' : 'about', route: isLoggedIn && patron ? `/patrons/${patron.id}/events` : '/about' },
                    { id: 'support', route: '/support' },
                    { id: isLoggedIn ? 'account' : 'login', route: isLoggedIn && patron ? `/patrons/${patron.id}/settings` : '/login' }
                ]}
                selectedIcon="support"
                navigate={navigate}
                location={location}
            />
        </div>
    );
}
